export const ApiPublicTag = {
  Features: 'Features',
}

export const ApiTagVer4 = {
  All: 'All',
  AssignmentStatus: 'AssignmentStatus',
  AttendanceGroup: 'AttendanceGroup',
  Enduser: 'Enduser',
  EnduserPicture: 'EnduserPicture',
  GroupAssignment: 'GroupAssignment',
  Role: 'Role',
  Tour: 'Tour',
  Zone: 'Zone',
  Device: 'Device',
  Contract: 'Contract',
  Owner: 'Owner',
  Client: 'Client',
  Web: 'Web',
  Application: 'Application',
}
